module.exports = __webpack_public_path__ + "static/media/latestdevelopments2.26290507.png";